/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_NotesInputs */

const en_directory_submit_notes = /** @type {(inputs: Directory_Submit_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes for reviewers (optional)`)
};

const zh_directory_submit_notes = /** @type {(inputs: Directory_Submit_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给审核员的备注（可选）`)
};

/**
* | output |
* | --- |
* | "Notes for reviewers (optional)" |
*
* @param {Directory_Submit_NotesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_notes = /** @type {((inputs?: Directory_Submit_NotesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_NotesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_notes(inputs)
	return zh_directory_submit_notes(inputs)
});
export { directory_submit_notes as "directory.submit.notes" }